import { render, staticRenderFns } from "./tabCrmCustomerFile.vue?vue&type=template&id=0b8ecf25&"
import script from "./tabCrmCustomerFile.vue?vue&type=script&lang=js&"
export * from "./tabCrmCustomerFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8ecf25')) {
      api.createRecord('0b8ecf25', component.options)
    } else {
      api.reload('0b8ecf25', component.options)
    }
    module.hot.accept("./tabCrmCustomerFile.vue?vue&type=template&id=0b8ecf25&", function () {
      api.rerender('0b8ecf25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/crm/tabs/tabCrmCustomerFile.vue"
export default component.exports